/**
 * Amount substracted from maximum value
 */
export const SUBSTRACT_AMOUNT = 0.0001;
